// LP（appful.tokyo）の本文と同じ日本語の字体（VDL V7丸ゴシック）を、LP と同じ Adobe Fonts のキットから読む。
// キットは字体を全部（約 6MB）読むので、絵とゲームを先に読み終えてから、空いている時に読み始める。
// 読み終わるまでは Zen Maru Gothic で出し、読み終わるとキットが <html> に wf-active を付けて theme.css が切り替える
// （字が消えている間を作らない）。読めなくても Zen Maru Gothic のまま使える。
const KIT = "sjk4wsu";

type Typekit = { load(config: { async: boolean }): void };

export function loadBrandFonts(): void {
  const start = () => {
    const s = document.createElement("script");
    s.src = `https://use.typekit.net/${KIT}.js`;
    s.async = true;
    s.onload = () => {
      try {
        (window as unknown as { Typekit?: Typekit }).Typekit?.load({ async: true });
      } catch {
        // 読めなければ Zen Maru Gothic のまま
      }
    };
    document.head.append(s);
  };
  const idle = () => ("requestIdleCallback" in window ? requestIdleCallback(start, { timeout: 3000 }) : setTimeout(start, 1000));
  if (document.readyState === "complete") idle();
  else addEventListener("load", idle, { once: true });
}
